module.exports = __webpack_public_path__ + "img/small_t4_fine_nut.prt.c0f70940.jpg";